module.exports = __webpack_public_path__ + "img/reserved.31886b73.svg";